export default {
  'app.settings.menuMap.basic': 'Основные настройки',
  'app.settings.menuMap.security': 'Настройки безопасности',
  'app.settings.menuMap.binding': 'Привязка аккаунта',
  'app.settings.menuMap.notification': 'Уведомления о новых сообщениях',
  'app.settings.basic.avatar': 'Аватар',
  'app.settings.basic.change-avatar': 'Изменить аватар',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Пожалуйста, введите ваш email!',
  'app.settings.basic.nickname': 'Никнейм',
  'app.settings.basic.nickname-message': 'Пожалуйста, введите ваш никнейм!',
  'app.settings.basic.profile': 'Личный профиль',
  'app.settings.basic.profile-message': 'Пожалуйста, введите ваш личный профиль!',
  'app.settings.basic.profile-placeholder': 'Краткое описание о себе',
  'app.settings.basic.country': 'Страна/Регион',
  'app.settings.basic.country-message': 'Пожалуйста, введите вашу страну!',
  'app.settings.basic.geographic': 'Провинция или город',
  'app.settings.basic.geographic-message': 'Пожалуйста, введите вашу географическую информацию!',
  'app.settings.basic.address': 'Почтовый адрес',
  'app.settings.basic.address-message': 'Пожалуйста, введите ваш адрес!',
  'app.settings.basic.phone': 'Номер телефона',
  'app.settings.basic.phone-message': 'Пожалуйста, введите ваш телефон!',
  'app.settings.basic.update': 'Обновить информацию',
  'app.settings.security.strong': 'Сильный',
  'app.settings.security.medium': 'Средний',
  'app.settings.security.weak': 'Слабый',
  'app.settings.security.password': 'Пароль аккаунта',
  'app.settings.security.password-description': 'Текущая сила пароля',
  'app.settings.security.phone': 'Безопасный телефон',
  'app.settings.security.phone-description': 'Привязанный телефон',
  'app.settings.security.question': 'Вопрос безопасности',
  'app.settings.security.question-description':
    'Вопрос безопасности не установлен, и политика безопасности может эффективно защитить безопасность аккаунта',
  'app.settings.security.email': 'Резервный email',
  'app.settings.security.email-description': 'Привязанный email',
  'app.settings.security.mfa': 'Устройство MFA',
  'app.settings.security.mfa-description':
    'Непривязанное устройство MFA, после привязки может быть подтверждено дважды',
  'app.settings.security.modify': 'Изменить',
  'app.settings.security.set': 'Установить',
  'app.settings.security.bind': 'Привязать',
  'app.settings.binding.taobao': 'Привязка Taobao',
  'app.settings.binding.taobao-description': 'В настоящее время непривязанный аккаунт Taobao',
  'app.settings.binding.alipay': 'Привязка Alipay',
  'app.settings.binding.alipay-description': 'В настоящее время непривязанный аккаунт Alipay',
  'app.settings.binding.dingding': 'Привязка DingTalk',
  'app.settings.binding.dingding-description': 'В настоящее время непривязанный аккаунт DingTalk',
  'app.settings.binding.bind': 'Привязать',
  'app.settings.notification.password': 'Пароль аккаунта',
  'app.settings.notification.password-description':
    'Сообщения от других пользователей будут уведомлены в форме письма со станции',
  'app.settings.notification.messages': 'Системные сообщения',
  'app.settings.notification.messages-description':
    'Системные сообщения будут уведомлены в форме письма со станции',
  'app.settings.notification.todo': 'Уведомления о делах',
  'app.settings.notification.todo-description':
    'Список дел будет уведомлен в форме письма со станции',
  'app.settings.open': 'Открыть',
  'app.settings.close': 'Закрыть',
};
